import styled from 'styled-components/macro';

export const Court = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  max-width: 270px;

  img {
    width: 100%;
    transform: ${({ inverted }) => inverted && 'rotateZ(180deg)'};
  }
`;

export const ColumnContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ inverted }) => inverted && 'row-reverse'};
  padding: 3% 3%;
`;

export const Column = styled.div`
  display: flex;
  height: 100%;
  flex-direction: ${({ inverted }) => (inverted ? 'column' : 'column-reverse')};
  align-items: center;
  justify-content: space-around;
  z-index: 0;

  svg {
    cursor: default;
  }
`;
